module.exports = __webpack_public_path__ + "static/006-285cf2396c44188dc47044c387dc6039.jpg";